// removed by extract-text-webpack-plugin
module.exports = {"active-indicator":"active-indicator","activeIndicator":"active-indicator","item-row":"item-row","itemRow":"item-row","text":"text"};


//////////////////
// WEBPACK FOOTER
// ./src/components/portal/controls/activeIndicator/style.scss
// module id = 1440
// module chunks = 0